import { MemoryRouter } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import { ThemeProvider } from 'providers/ThemeProvider';
import { AuthProvider } from 'hooks/useAuth';
import { GlobalStyles } from '../../style';
import DefaultLayout from 'public/components/DefaultLayout';
import {
  BannerProvider,
  CategoryProvider,
  ProductProvider,
} from 'public/context';
import { FarmProvider } from 'public/context/FarmContext';
import { FilterProvider } from 'public/context/FilterContext';
import { CartProvider } from 'public/context/CartContext';
import { useBreakpoint } from 'utils/useBreakpoint';
import translations from '../../languages/lv.json';
import { exportIds } from '../../config/config';
import { ExportContent, ExportStyles, ExportWrapper } from './style';

const locale = 'lv';

const EXPORT_WIDTH_DESKTOP = 1482;
const EXPORT_WIDTH_MOBILE = 440;

interface ExportAppProps {
  exportUrl: string;
}

export const ExportApp = ({ exportUrl }: ExportAppProps) => {
  const { isLgDown } = useBreakpoint();
  const contentWidth = isLgDown ? EXPORT_WIDTH_MOBILE : EXPORT_WIDTH_DESKTOP;

  return (
    <IntlProvider locale={locale} messages={translations}>
        <MemoryRouter initialEntries={[exportUrl]} initialIndex={0}>
          <ThemeProvider>
            <FarmProvider>
              <ProductProvider>
                <CategoryProvider>
                  <CartProvider>
                    <BannerProvider>
                      <FilterProvider>
                        <AuthProvider>
                          <GlobalStyles />
                          <ExportStyles />
                          <ExportWrapper $contentWidth={contentWidth}>
                            <ExportContent
                              id={exportIds.pdfExportContent}
                              $contentWidth={contentWidth}
                            >
                              <DefaultLayout />
                            </ExportContent>
                          </ExportWrapper>
                        </AuthProvider>
                      </FilterProvider>
                    </BannerProvider>
                  </CartProvider>
                </CategoryProvider>
              </ProductProvider>
            </FarmProvider>
          </ThemeProvider>
        </MemoryRouter>
      </IntlProvider>
  );
};
